export const userContactInfo = {
  name: '',
  email: '',
  phoneNumber: '',
  dialCode: '',
};